var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "expandable-card",
      style: {
        backgroundColor: _vm.getCardBackgroundColor(_vm.property.status)
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "header-section",
          style: {
            backgroundColor: _vm.getCardBackgroundColor(_vm.property.status)
          },
          on: { click: _vm.toggleExpand }
        },
        [
          _c(
            "div",
            {
              staticClass: "header-grid",
              style: {
                backgroundColor: _vm.getCardBackgroundColor(_vm.property.status)
              }
            },
            [
              _c("div", { staticClass: "header-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Residence")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.apt))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "header-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Status")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.status))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "header-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Beds")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.beds))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "header-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Baths")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.baths))
                ])
              ]),
              _vm._v(" "),
              _c("i", {
                class: ["el-icon-arrow-right", { "is-active": _vm.isExpanded }]
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isExpanded,
              expression: "isExpanded"
            }
          ],
          staticClass: "expanded-content"
        },
        [
          _c("div", { staticClass: "content-section" }, [
            _c("div", { staticClass: "content-grid" }, [
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Cars")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.cars))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Internal m"),
                  _c("sup", [_vm._v("2")])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.internal))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Alfresco m"),
                  _c("sup", [_vm._v("2")])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.balcony))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Total m"),
                  _c("sup", [_vm._v("2")])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.total))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-section" }, [
            _c("div", { staticClass: "content-grid" }, [
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Land m"),
                  _c("sup", [_vm._v("2")])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.property.landm2))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Land Price")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.getPriceCommon(_vm.property.landPrice)))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Build Price")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.getPriceCommon(_vm.property.buildingPrice)))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Total Price")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getPrice(
                        _vm.property.totalPrice,
                        _vm.property.totalPriceMax
                      )
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-section" }, [
            _c("div", { staticClass: "content-grid-three" }, [
              _c("div", { staticClass: "content-item" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Est. Rental (pw)")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getPriceCommon(
                        _vm.property.anticipatedRent,
                        _vm.property.anticipatedRentMax
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }),
              _vm._v(" "),
              _c("div", { staticClass: "content-item" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("Floorplan")]),
                  _vm._v(" "),
                  _vm.property.floorPlansUrl
                    ? _c("el-image", {
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "auto",
                          "margin-right": "auto",
                          "max-height": "40px"
                        },
                        attrs: {
                          "preview-src-list": [_vm.property.floorPlansUrl],
                          src: require("../../assets/u1.png")
                        }
                      })
                    : _c("span", { staticClass: "value" }, [_vm._v("N/A")])
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c009ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c009ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/propertyDetails/houseAndLandPricelist.vue
// module id = null
// module chunks = 